import React from 'react'
import { Stack, Table, Text } from '@mantine/core'
import { useTheme } from '../../../../components/ThemeProvider'
import { dictionaries } from '../utils/dictionaries'
import { decodeFromDictionary } from '../types'

type Props = {
  data: any
}

const rows = [
  { label: '当前逾期机构数', key: 'xyp_cpl0071' },
  { label: '当前逾期金额', key: 'xyp_cpl0072' },
]

export default function OverdueTable({ data }: Props) {
  const theme = useTheme()
  const hasOverdue = data?.xyp_cpl0044 === '1'

  return (
    <Stack gap="sm">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        逾期情况
      </Text>
      <Table
        highlightOnHover
        verticalSpacing="sm"
        withColumnBorders={false}
        styles={{
          table: { fontSize: '13px', tableLayout: 'fixed' },
          th: {
            backgroundColor: theme.surfaceMutedColor,
            color: theme.accentTextColor,
            whiteSpace: 'nowrap',
          },
        }}
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th style={{ width: '40%' }}>指标</Table.Th>
            <Table.Th style={{ width: '60%' }}>结果</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          <Table.Tr>
            <Table.Td>当前是否存在逾期</Table.Td>
            <Table.Td style={{ color: hasOverdue ? theme.warningColor : theme.primaryColor }}>
              {hasOverdue ? '是' : '否'}
            </Table.Td>
          </Table.Tr>
          {rows.map((row) => (
            <Table.Tr key={row.key}>
              <Table.Td>{row.label}</Table.Td>
              <Table.Td>{decodeFromDictionary(dictionaries, row.key, data?.[row.key])}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Stack>
  )
}
